import React, { useEffect, useState } from 'react';
import PageContent from '../../components/layout/PageContent';
import axios from 'axios';
import CustomForm from '../../components/form/CustomForm';
import { useHistory } from 'react-router-dom';

const RoleEdit = ({
	location: { state: { id = null } = {} } = {},
}) => {

	const [ fields, setFields ] = useState([]);
	const [ loadingFields, setLoadingFields ] = useState(false);

	const history = useHistory();

	useEffect(() => {
		setLoadingFields(true);
		axios.get(`/api/1.0/permission/${id}`)
		.then(({ data = {} }) => {
			const { result = {  } } = data;
			setFields(result?.data ?? []);
		})
		.catch(err => {
			console.error('Fetch Permission: ', err);
		})
		.finally(() => setLoadingFields(false))
	}, [id]);

	const handleSubmit = (fields) => {
		return axios.post(`/api/1.0/permission/${id}`, fields)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/permission');
			}
		})
		.catch(err => {
			console.error('Update Permission: ', err);
		})
	}

	const handleCancel = () => {
		history.push('/permission')
	}

	return (
		<PageContent
			background='#ffffff'
			subheader={{
				title: 'Өгөгдөлд хандах эрх засах',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={fields}
				loading={loadingFields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
			/>
		</PageContent>
	)
}

export default RoleEdit;